export default {
  presenter: 'panelova_diskusia',
  title: 'Panelová diskuze',
  subtitle: '',
  text: `
Vedená diskuze v trvání 1,5 hodiny se zástupci různych směru vzdělávání, napr. Montessori, Scio, štátna škola, súkromná škola..., kde budeme rozebírat výhody a nevýhody jednotlivých typů vzdelávání. 
Zůčastní se například Ivan Juráš, Vítězslav Dohnal, Markéta Olbertová, Juraj Šimkovič, Alexander Jakubčo, Hana Svobodová, Veronika Kanýzová...
  `,
}



// WEBPACK FOOTER //
// ./src/content/vychovakzivotu/data/presentations/c02_panelova_diskusia.js